import React from 'react';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/client';
import './MaintenancePage.css';

const messages = {
  lt: {
    title: 'Atnaujinimo darbai',
    text: 'Šiuo metu vykdome parduotuvės atnaujinimą/testavimą. Parduotuvė netrukus taps vėl pasiekiama.',
  },
  en: {
    title: 'Maintenance',
    text: 'We are currently performing store updates/testing. The store will be available again shortly.',
  },
  de: {
    title: 'Wartung',
    text: 'Wir führen derzeit Shop-Updates/Tests durch. Der Shop ist in Kürze wieder erreichbar.',
  },
};

function MaintenancePage() {
  const { data: storeSettings } = useQuery({
    queryKey: ['store-settings'],
    queryFn: async () => {
      const res = await apiClient.get('/store-settings');
      return res.data;
    },
  });

  const logoUrl = storeSettings?.logo_url || storeSettings?.footer_logo_url;
  const companyName = storeSettings?.company_name || '';
  const displayCompanyName = companyName === 'Cloudrix MB' ? 'MAGTIC®' : companyName;

  return (
    <div className="maintenance-page" role="main">
      <div className="maintenance-page-inner">
        <div className="maintenance-content">
          {logoUrl && (
            <div className="maintenance-logo">
              <img
                src={logoUrl.startsWith('http') || logoUrl.startsWith('/') ? logoUrl : `/${logoUrl}`}
                alt={displayCompanyName || 'Logo'}
              />
            </div>
          )}
          <h1 className="maintenance-title">Wartung / Maintenance</h1>
          <div className="maintenance-text-all">
            <p className="maintenance-text maintenance-text-lang">{messages.de.text}</p>
            <p className="maintenance-text maintenance-text-lang">{messages.en.text}</p>
            <p className="maintenance-text maintenance-text-lang">{messages.lt.text}</p>
          </div>
        </div>
      </div>
      <footer className="maintenance-footer">
        {displayCompanyName && (
          <p className="maintenance-footer-name">{displayCompanyName}</p>
        )}
      </footer>
    </div>
  );
}

export default MaintenancePage;
